import { defineMessages } from 'react-intl';

export default defineMessages({
    stepCoverables: {
        id: 'quoteandbind.ProLinProduct.wizard.step.Coverables',
        defaultMessage: 'Coverables'
    },
    questions: {
        id: 'quoteandbind.ProLinProduct.wizard.step.Questions',
        defaultMessage: 'Questions'
    },
    stepCoverages: {
        id: 'quoteandbind.ProLinProduct.wizard.step.Coverages',
        defaultMessage: 'Coverages'
    },
    exposures: {
        id: 'quoteandbind.ProLinProduct.wizard.step.Exposures',
        defaultMessage: 'Exposures'
    }
    // add string ids and default values for localization here
});
